
const state = {
  campaign_id: undefined,
  contact_name: '',
  creditor_id: undefined,
  creditor_type: '',
  id: null,
  notes: '',
  reference: '',
}

export const requiredFields = []

export default state
